import * as core from '../../../../../../../core'

import { query } from './traceability-matrix-awaiting-approval.query'

export const RESOURCE = {
  payload: {
    alias: 'traceability-matrix.awaiting-approval',
    description:
      'Count of requirements whose spec has no merged approval pull request',
    name: 'Traceability Matrix - Awaiting Approval',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
